const mutations = {
  SET_AGENT_DATA(state, payload) {
    state.AGENT_DATA = payload;
  },
  SET_TRANSACTIONS(state, payload) {
    state.TRANSACTIONS = payload;
  }
};

export { mutations };
